<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">配对列表</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>配对状况：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>是否加速：</label>
          <el-select v-model="speedUp" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in speedUpArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>公开头像：</label>
          <el-select v-model="openHead" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in openHeadArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>查看主页：</label>
          <el-select v-model="visitResume" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in visitResumeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>

        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
        >
          <el-table-column property="createTime" label="配对时间" v-if="checkColList.indexOf('配对时间') > -1"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" >
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="配对用户" v-if="checkColList.indexOf('配对用户') > -1" >
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" >
            <template #default="scope">
              <div v-if="scope.row.toResume">
                <el-image style="width: 80px; height: 80px" :src="scope.row.toResume.headImg.smallHeadImg" @click="showImg(scope.row.toResume)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="被配对用户" v-if="checkColList.indexOf('被配对用户') > -1" >
            <template #default="scope">
              <div v-if="scope.row.toResume">
                <UserInfoList :row="scope.row.toResume" showList="name,phone,uid,city"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="聊天内容" v-if="checkColList.indexOf('聊天内容') > -1" class-name="cursor">
            <template #default="scope">
              <p><span style="color: #1094fa">{{ scope.row.chatNum }}</span></p>
            </template>
          </el-table-column>
          <el-table-column property="" label="配对状态" v-if="checkColList.indexOf('配对状态') > -1">
            <template #default="scope">
              <p>
                {{ scope.row.state == 0 ? '失败' : scope.row.state == 1 ? '成功' : '' }}
                （{{ scope.row.speedUp == 0 ? '未加速' : scope.row.speedUp == 1 ? '加速' : '' }}）
              </p>
            </template>
          </el-table-column>
          <el-table-column property="" label="公开头像" v-if="checkColList.indexOf('公开头像') > -1">
            <template #default="scope">
              <p>{{ scope.row.openHead == -1 ? '不展示' : scope.row.openHead == 0 ? '双方未公开' : scope.row.openHead == 1 ? '双方已公开' : scope.row.openHead == 2 ? '仅男生公开' : scope.row.openHead == 3 ? '仅女生公开' : '' }}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="查看主页" v-if="checkColList.indexOf('查看主页') > -1">
            <template #default="scope">
              <p>{{ scope.row.visitResume == -1 ? '不展示' : scope.row.visitResume == 0 ? '双方未查看' : scope.row.visitResume == 1 ? '双方已查看' : scope.row.visitResume == 2 ? '仅男生查看' : scope.row.visitResume == 3 ? '仅女生查看' : '' }}</p>
            </template>
          </el-table-column>
<!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">-->
<!--            <template #default="scope">-->
<!--              <UserLog :user-log-list="scope.row.userLogList" />-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getOnlineChatPageList, getUserChatResume, listBlockRuleSpecial,
} from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import ChatUserContentList from "@/views/chat/components/content/ChatUserContentList";

export default {
  name: "InteractMsg",
  components: { DatePickerRange, SearchComponents},
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],


      //配对状况
      stateArray: [
        {label: '不限', value: -1},
        {label: '成功', value: 1},
        {label: '失败', value: 0},
      ],
      state: -1,

      //配对状况
      speedUpArray: [
        {label: '不限', value: -1},
        {label: '加速', value: 1},
        {label: '未加速', value: 0},
      ],
      speedUp: -1,

      //公开头像
      openHeadArray: [
        {label: '不限', value: -1},
        {label: '双方未公开', value: 0},
        {label: '双方已公开', value: 1},
        {label: '仅男生公开', value: 2},
        {label: '仅女生公开', value: 3},
      ],
      openHead: -1,

      //查看主页
      visitResumeArray: [
        {label: '不限', value: -1},
        {label: '双方未查看', value: 0},
        {label: '双方已查看', value: 1},
        {label: '仅男生查看', value: 2},
        {label: '仅女生查看', value: 3},
      ],
      visitResume: -1,

      //IM/纸条时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchTypeList: [
        {label: '配对用户', value: 1},
        {label: '被配对用户', value: 2},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['配对时间', '头像', '配对用户', '头像', '被配对用户', '聊天内容', '配对状态', '公开头像', '查看主页'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

      blockContentArray: [
        {label: '不限', value: ''}
      ],
      blockContent: '',

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getRegTime(val) {
      this.userStartTime = val[0];
      this.userEndTime = val[1];
      // console.log(val)
    },
    getRegCheck(val) {
      this.isRegChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.state = -1;
      this.speedUp = -1;
      this.openHead = -1;
      this.visitResume = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['speedUp'] = this.speedUp;
      param['openHead'] = this.openHead;
      param['visitResume'] = this.visitResume;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getOnlineChatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if (column.label == '聊天内容') {
        if(!row.chatNum) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '没有聊天记录',
            type: 'warning'
          });
          return
        }
        let param = {};
        param['userId'] = row.userId;
        param['toUserId'] = row.toUserId;
        getFormData(getUserChatResume, param).then((data) => {
          let {msg, code } = data;
          if(code == 200) {
            let resumeInfo = data['data'];
            Dialog.open({
              title: '聊天对话列表',
              component: ChatUserContentList,
              data: {
                userId: row.userId,
                toUserId: row.userId,
                resumeInfo: resumeInfo,
                state: -1,
                blockContentArray: this.blockContentArray,
                width: '1100px'
              },
              close: () => {

              }
            })
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      }

    },

    //获取关键词列表
    getSpecialList() {
      getFormData(listBlockRuleSpecial).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          result.map(item => {
            let obj = {};
            obj.label = item;
            obj.value = item;
            this.blockContentArray.push(obj)
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getSpecialList();
  }
}
</script>

<style scoped>

</style>
